import { render, staticRenderFns } from "./ChatSeparatorMessage.vue?vue&type=template&id=ff239b78"
import script from "./ChatSeparatorMessage.vue?vue&type=script&lang=js"
export * from "./ChatSeparatorMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatSeparatorMessage.vue?vue&type=style&index=0&id=ff239b78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports